import { createFileRoute, redirect } from '@tanstack/react-router';

// Kept for saved tabs and `open/routine-chats?template=` share links
export const Route = createFileRoute('/_authenticated/routine-chats/')({
  beforeLoad() {
    throw redirect({ to: '/routines', search: true, replace: true });
  },
});
